import { z } from "zod";
import { TopolSectionSchema } from "../templateSchema";
import { TopolSpecialBlockTranslationSchema } from "../template/languageSchema";

const baseSavedBlockSchema = z.object({
  id: z.number(),
  name: z.string(),
  img: z.string().nullable().optional(),
  definition: z.array(TopolSectionSchema).or(TopolSectionSchema),
  translation: TopolSpecialBlockTranslationSchema.optional().catch(undefined),
});

type SavedBlockInput = z.input<typeof baseSavedBlockSchema> & {
  children?: SavedBlockInput[];
};

type SavedBlockOutput = z.output<typeof baseSavedBlockSchema> & {
  children?: SavedBlockOutput[];
};

export const SavedBlockSchema: z.ZodType<SavedBlockOutput, SavedBlockInput> =
  baseSavedBlockSchema.extend({
    children: z.lazy(() => SavedBlockSchema.array()).optional(),
  }) as z.ZodType<SavedBlockOutput, SavedBlockInput>;

export const SavedBlocksSchema = z
  .array(SavedBlockSchema)
  .or(z.boolean())
  .nullable();

export type ISavedBlocks = z.infer<typeof SavedBlocksSchema>;
export type ISavedBlock = z.infer<typeof baseSavedBlockSchema>;

export type ISavedBlockDefinition = z.infer<
  typeof baseSavedBlockSchema
>["definition"];
